import React, { memo, useEffect, useMemo, useState } from 'react';
import bem from 'utils/bem';
import { IconButton } from 'components/Button';
import './index.sass';

const { block, el } = bem('slider');

const Slider = memo(({ items, number = 3 }) => {
    const slidesLength = Math.ceil(items.length / number);
    const [ current, setCurrent ] = useState(0);
    const [ disabled, setDisabled ] = useState(false);
    const [ initial, setInitial ] = useState(true);

    useEffect(() => {
        setCurrent(0)
    }, [items])

    useEffect(() => {
        setDisabled(true)
        const timer = setTimeout(() => {
            setDisabled(false);
        }, 500);
        return () => {
            clearTimeout(timer);
        }
    }, [current]);

    const buildSlides = () => {
        const slidesItems = [];
        for (let i = 0; i < slidesLength; i++) {
            slidesItems[i] = [];
            for (let j = 0; j < number; j++) {
                const visible = initial && i === 0;
                const slide = <div key={i * number + j} className={el('slide-item', { visible })}>
                    {items[i * number + j]}
                </div>
                slidesItems[i].push(slide);
            }
        }
        return slidesItems.map((slide, i) => (
            <div key={i} className={el('slide', {'current': i === current})}>
                { slide }
            </div>
        ))
    }

    const onClickNext = () => {
        setInitial(false);
        setCurrent(oldCurrent => {
            return Math.min(++oldCurrent, slidesLength - 1)
        })
    }
    const onClickPrev = () => {
        setInitial(false);
        setCurrent(oldCurrent => {
            return Math.max(--oldCurrent, 0)
        })
    }

    const slides = buildSlides()

    return (
        <div className={block()} >
            <div className={el('window')}>
                {slides}
            </div>
            <div className={el('buttons')}>
                <IconButton className={el('button', {disabled})} mod={'transparent-gold'} name={'arrow-right'} onClick={onClickNext} type={'button'} disabled={current === slidesLength - 1} />
                <IconButton className={el('button', {disabled})} mod={'transparent-gold'} name={'arrow-left'} onClick={onClickPrev} type={'button'} disabled={current === 0}/>
            </div>
        </div>
    )
})

export default Slider;
